@if (imageUrl()) {
  <span class="avatar {{sizeStyle()}}" [style.background-image]="'url(' + imageUrl() + ')'"></span>
} @else {
  <span class="avatar {{sizeStyle()}}">
    <i class="fa-light fa-newspaper fa-lg"></i>
  </span>
}